export interface Interval {
  id: number;
  startTime: number;
  endTime: number;
  title?: string;
}

/** Remove the interval with `id`. Refuses to delete the last remaining
 *  interval — a clip must always have at least one segment — returning the
 *  input list unchanged in that case. Never mutates the input. */
export function removeInterval<T extends Interval>(intervals: T[], id: number): T[] {
  if (intervals.length <= 1) return intervals;
  return intervals.filter((it) => it.id !== id);
}
